import React,{useState} from 'react'
import '../css/listproduct.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping, faE } from "@fortawesome/free-solid-svg-icons";
import {faEye} from "@fortawesome/free-solid-svg-icons"
import { faHeart } from "@fortawesome/free-solid-svg-icons"
import { Pagination } from 'react-bootstrap';

function Listproduct(props) {
    const [currentPage, setCurrentPage] = useState(1);
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
      };
    return (
      <>
      <div className='list-wrapper'>
          <div className='product-image'>
          <img src={props.src} />
          </div>
          <div className='product-content'>
              <h3>Coffee machine</h3> 
              <div className='price'>
                  
                  <p>$1999,- </p><p>$1755,-</p>
                  
              </div>
              <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit.Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span>
              <div className='shop-icon'><FontAwesomeIcon className='icon' icon={faCartShopping} /></div>
              <div className='like-button'><FontAwesomeIcon className='icon' icon={faHeart} /></div>
              <div className='view-button'><FontAwesomeIcon className='icon' icon={faEye} /></div>
          </div>
      </div>
            
      </>
  )
}

export default Listproduct